import React from 'react';
import PropTypes from 'prop-types';
import { MultiButtonModal } from 'web-ui-components/lib/layout/content';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import content from './Notifications.content';

export function NameNotCheckedModal({ handleContinue, handleCancel }) {
	const buttons = [
		<NavigationButton.Primary labelText={content.checkNowBtn} onClick={handleContinue} />,
		<NavigationButton.Secondary labelText={content.cancelBtn} onClick={handleCancel} />,
	];
	return (
		<MultiButtonModal buttons={buttons} isOpen={true} onClose={handleCancel} data-test-id="cop-name-not-checked-modal">
			<GenericFieldWrapper description={content.nameNotCheckedBody} titleText={content.nameNotCheckedTitle} />
		</MultiButtonModal>
	);
}

NameNotCheckedModal.propTypes = {
	handleContinue: PropTypes.func.isRequired,
	handleCancel: PropTypes.func.isRequired,
};
